<script setup>
import CircleHelpIcon from "@/components/Icons/CircleHelpIcon.vue";
import {ref} from "vue";
import { t } from "@/controllerLK/AvalLocalization";

const isShowTooltip = ref(false);

const toggleShowTooltip = () => {
  isShowTooltip.value = !isShowTooltip.value;
};

const hideTooltip = () => {
  isShowTooltip.value = false;
};
</script>

<template>
  <div class="help-tooltip">
    <div
      class="help-tooltip__trigger"
      :class="{'help-tooltip__trigger--active': isShowTooltip}"
      @click="toggleShowTooltip"
    >
      <CircleHelpIcon />
    </div>
    <div
      v-if="isShowTooltip"
      v-click-outside:[`.help-tooltip__trigger`]="hideTooltip"
      class="help-tooltip__popup"
    >
      <div class="help-tooltip__content">
        <span class="help-tooltip__text">{{ t('news_page_rubrics_edit_popup.query_tooltip.title') }}</span>
        <span class="help-tooltip__text">
          <span class="help-tooltip__text_bold">AND</span>
          — {{ t('news_page_rubrics_edit_popup.query_tooltip.and') }}
        </span>
        <span class="help-tooltip__text">
          <span class="help-tooltip__text_bold">OR</span> — {{ t('news_page_rubrics_edit_popup.query_tooltip.or') }}
        </span>
        <span class="help-tooltip__text">
          <span class="help-tooltip__text_bold">NOT</span> — {{ t('news_page_rubrics_edit_popup.query_tooltip.not') }}
        </span>
      </div>
      <div
        class="help-tooltip__close"
        @click="hideTooltip"
      >
        <AvalIconCross />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.help-tooltip {
  display: flex;
  justify-content: center;
  position: relative;
  margin-left: auto;

  &__trigger {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--icon-icon-primary);

    &:hover {
      color: var(--icon-icon-on);
    }

    &--active {
      color: var(--icon-icon-on);
    }

    svg {
      width: 20px;
      height: 20px;
    }
  }

  &__popup {
    border-radius: 8px;
    display: flex;
    gap: 8px;
    position: absolute;
    padding: 10px 8px 10px 14px;
    background-color: var(--background-bg-white);
    width: 319px;
    top: calc(100% );
    box-shadow: 1px 2px 10px 0 var(--gray-gray50);
    z-index: 10;
    right: 4px;
  }

  &__content {
    display: flex;
    flex-direction: column;
  }

  &__text {
    font-size: 12px;
    line-height: 17px;
    font-weight: 400;

    &_bold {
      font-size: 12px;
      font-weight: 700;
    }
  }

  &__close {
    width: 20px;
    height: 20px;
    color: var(--icon-icon-secondary);
    cursor: pointer;
    user-select: none;

    &:hover {
      color: var(--icon-icon-on);
    }

    svg {
      width: 14px;
      height: 14px;
    }
  }
}

</style>